
import { defineComponent } from 'vue';
import DriveInput from '@/modules/drive/components/UI/DriveInput.vue';
import DriveFiles from '@/modules/drive/components/UI/DriveFiles.vue';
import { HIDE_BORDER } from '@/types/enums';
import AppHeader from '../AppHeader.vue';
import DriveUiWrapper from '@/modules/drive/components/UI/DriveUIWrapper.vue';
import AppLabelInput from '../UI/AppLabelInput.vue';
import DriveInfo from '@/modules/drive/components/UI/DriveInfo.vue';

export default defineComponent({
  props: {
    title: { type: String, default: '' },
    photoSkeletons: { type: Number, default: 0 },
    fileSkeletons: { type: Number, default: 0 },
  },
  components: {
    DriveInput,
    DriveFiles,
    AppHeader,
    DriveUiWrapper,
    AppLabelInput,
    DriveInfo,
  },
  setup() {
    return {
      HIDE_BORDER,
    };
  },
});
